import styled from "styled-components";

export const ToggleButtonGroup = styled.div`
  display: flex;
  border: none;
  border-radius: 999px;
  background-color: #ebebf0;
`;

export const Button = styled.button<{ selected: boolean }>`
  padding: 4px 24px;
  border: none;
  background-color: ${(props) => (props.selected ? "#0041D9" : "transparent")};
  color: ${(props) => (props.selected ? "#fff" : "#555770")};
  border-radius: 999px;
  cursor: pointer;

  &:hover {
    //background-color: #0041d9;
    //color: #fff;
  }

  &:focus {
    outline: none;
  }

  &:not(:first-child):not(:last-child) {
    box-shadow: ${(props) => (!props.selected ? "-1px 0 0 0 #ccc" : "none")};
  }
`;
